import React ,{useState,useEffect}from 'react';
// import axios from 'axios';
import { makeStyles} from '@material-ui/core/styles';
import Sidebar from '../component/Sidebar';
import Bread from '../component/Breadcrumbs';
import {UserList} from '../Services/User';
import Datatable from '../component/Datatable';
import {AuthData} from '../Services/Authdata';
// import Grid from '@material-ui/core/Grid';
// import tripImage from '../../public/Images/trip.jpg';
import MaterialIcons from '../component/MaterialIcons';
import Button from '@material-ui/core/Button';
import {Link} from 'react-router-dom';
import Swal from 'sweetalert2';
import {blockUser} from '../Services/User';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';




const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  trip_image:{
    width:'100px',
    height:'100px'
  }

}));


export default function DestinationList(props) {
  const br = [{
    'title':'Trip',
    'icon':"",
    'url':'/trip'
  }];


  const classes = useStyles();
  const [data, setData] = useState([]);
  // const [state,setState] = useState([]);
  const [srow, setSrow] = useState([]);
  const [max, setMax] = useState(0);
  useEffect(() =>{
    UserList('destination','GET',AuthData().token).then((result)=>{
      //console.log(result);
      setData(result.data);
      setMax(result.max);
      // if(props.location.state.message !== "" || props.location.state.message !== undefined){
      //   setMessage(props.location.state.message);
      //   setState({ ...state, open: true });
      // }
    })
  },[]);
  
  

//Active and Inactive Function for Trip
const tripStatus =(is_active,id)=>{
  // console.log(userId)
   if(is_active === 0){
     var mess = "Inactive";
   }else if(is_active === 1){
      mess = "Active";
   }else{
    mess = "Delete";
   }
   Swal.fire({
     title: 'Are you sure?',
     text: "You want to "+mess+" the Trip",
     icon: 'warning',
     showCancelButton: true,
     confirmButtonColor: '#3085d6',
     cancelButtonColor: '#d33',
     confirmButtonText: 'Ok'
   }).then((result) => {
     if (result.value) {

       blockUser('GET','destination/destination_status?id=['+id+']&type='+is_active,AuthData().token)
       .then((result)=>{
        //  console.log(result);
         if(result.status === 1){
           Swal.fire(
             'Success!',
             result.message,
             'success'
           ).then((val)=>{
            // UserList('destination','GET',AuthData().token).then((result)=>{
            //   if(result.status == 1){
            //     setData(result.data);
            //   }
            // })
            window.location.reload()
           })
           
         }else{
           Swal.fire(
             'Success!',
             result.message,
             'success'
           )
         }
         
       })
       
     }
   })
 }
//End


const rankUp = (e,type,destination_id) => {

  Swal.fire({
    title: 'Are you sure?',
    text: "You want to up the rank",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Ok'
  }).then((result) => {
    const url = 'destination/'+type+"/"+destination_id+"/"+e.target.value;
    if (result.value) {
      UserList(url,'GET',AuthData().token).then((result)=>{
        if(result.status === 1){
          // UserList('destination','GET',AuthData().token).then((result)=>{
          //   setData(result.data);
          //   setMax(result.max);
          // })
          Swal.fire(
            'Success!',
            'Rank has been changed Succesfully!!!',
            'success'
          ).then((val)=>{
            window.location.reload()
          })
        }
      })
    }
  })
}
const rankDown = (e,type,destination_id) => {
Swal.fire({
  title: 'Are you sure?',
  text: "You won't Down the Rank",
  icon: 'warning',
  showCancelButton: true,
  confirmButtonColor: '#3085d6',
  cancelButtonColor: '#d33',
  confirmButtonText: 'Ok'
}).then((result) => {
  if (result.value) {
    const url = 'destination/'+type+"/"+destination_id+"/"+e.target.value;
    UserList(url,'GET',AuthData().token).then((result)=>{
      if(result.status === 1){
        // UserList('destination','GET',AuthData().token).then((result)=>{
        //   setData(result.data);
        //   setMax(result.max);
        // })
        Swal.fire(
          'Success!',
          'Rank has been changed Succesfully!!!',
          'success'
        ).then((val)=>{
          window.location.reload()
        })
      }
    })
    
  }
})
}


  const columns = [
    {
        name: "name",
        label: "Name",
        options: {
        filter: true,
        sort: true,
        }
    },
    {
        name: "nickname",
        label: "NickName",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        name: "about",
        label: "About",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
      name: "destination_rank",
      label: "Rank",
      
      options: {
          filter: true,
          sort: true,
          customBodyRenderLite:(value, dataIndex,updateValue) => {
            const trip_id = data[dataIndex].id;
            const val = data[dataIndex].destination_rank;
            var select1 = [];
            var select2 = [];
          if(max > 0)
          {
            select1.push(<option disabled selected value>Down</option>);
            select2.push(<option disabled selected value>Up</option>);
            if(val > 0 )
            {
              for (let i = val + 1; i <= max ; i++) {
                //select1.push(<option key={i} value={i}>{i}</option>)
                select1.push(<MenuItem key={i} value={i} style={{fontSize:'14px'}}>{i}</MenuItem>)
              }
            }
            for (let i = val - 1; i > 0;) {
              //select2.push(<option key={i} value={i}>{i}</option>)
              select2.push(<MenuItem key={i} value={i} style={{fontSize:'14px'}}>{i}</MenuItem>)
              i--;
          }
          }
          
           return (
         <div className="ranking" style={{width:'150px'}}>
               <Select
                  labelId="demo-simple-select-outlined-label"
                  id="rankdown"
                  label="country"
                  name='rank Down'
                  data-id={val}
                  onChange={(e)=>{rankDown(e,'Down',trip_id)}}
                  style={{fontSize:'14px'}}
                >{select1}
                </Select>
                {data[dataIndex].destination_rank}
                <Select
                  labelId="demo-simple-select-outlined-label"
                  id="rankup"
                  label="country"
                  name='rank up'
                  style={{fontSize:'14px'}}
                  onChange={(e) => {rankUp(e,'Up',trip_id)}}
                  data-id={trip_id}
                >
                  {select2}
                </Select>

         </div>
         )
         }
      }
  },
    {
      name: "is_active",
      label: "Status",
      options: {
          filter: true,
          sort: true,
          customBodyRenderLite:(value, dataIndex,updateValue) => {
            const trip_id = data[dataIndex].id;
            if(data[dataIndex].is_active === 1){
                return <Button title="Active" onClick={()=>{tripStatus(0,trip_id)}}>
                          <MaterialIcons color="secondary" icon="check_circle_outline_two_tone"  size={20}/>
                      </Button>
            }else{
              return  <Button title="Inactive" onClick={()=>{tripStatus(1,trip_id)}}>
                      <MaterialIcons color="action" icon="check_circle_outline_two_tone" size={20}/>
                  </Button>
            }
          }
      }
    },
    {
        name: "image",
        label: "Image",
        options: {
            filter: true,
            sort: true,
            customBodyRenderLite:(value, dataIndex,updateValue) => {
                const a = (data[dataIndex].image).replace(/[\[\]']+/g,'').replace(/['"]+/g, '');
                let imgUrl = process.env.REACT_APP_AWS_URL+a;
               // console.log(imgUrl);
                return <img style={{width:'100px',height:"100px"}} src={imgUrl} alt="logo"/>
                //return (data[dataIndex].image).replace(/[\[\]']+/g,'');
            }
        }
    },
    {
      name: "thumb",
      label: "Thumbnails",
      options: {
          filter: true,
          sort: true,
          customBodyRenderLite:(value, dataIndex,updateValue) => {
              const a = (data[dataIndex].thumbnail).replace(/[\[\]']+/g,'').replace(/['"]+/g, '');
              let thumbUrl = process.env.REACT_APP_AWS_URL+a;
             // console.log(imgUrl);
              return <img style={{width:'50px',height:"50px"}} src={thumbUrl} alt="thumbnail"/>
              //return (data[dataIndex].image).replace(/[\[\]']+/g,'');
          }
      }
  },
    {
        name: "action",
        label: "Action",
        options: {
            filter: true,
            sort: true,
            customBodyRenderLite:(value, dataIndex,updateValue) => {
              const trip_id = data[dataIndex].id;
              //passing 2 for delete
                return (
                    <div>
                        <Button title="Delete" onClick={()=>{tripStatus(2,trip_id)}}>
                          <MaterialIcons color="secondary" icon="delete" size={20}/>
                        </Button>
                        <Button title="Edit">
                        <Link to={{
                          pathname:'trip/edit/'+trip_id,
                          state:{name:data[dataIndex]}
                        }}>
                        <MaterialIcons color="secondary" icon="edit" size={20}/>
                        </Link>
                          
                        </Button>
                    </div>
                );
            }
        }
    },
    
   ];
   const options = {
    filterType: 'dropdown',
    selectableRowsOnClick:false,
  //  selectableRows: "none",
    // draggableColumns: {
    //   enabled: true
    // },
    responsive: "standard",
   //  selectedRows: {
   //   text: "row(s) sdsdsdsdsselected",
   //   delete: "Delete",
   //   deleteAria: "Delete Selected Rows",
   // },
    onRowSelectionChange:(currentRowsSelected, allRowsSelected, rowsSelected) => {
       const abc = rowsSelected.map((r)=>{
         return data[r].id;
       })
        setSrow(abc);
    },
    //selectToolbarPlacement:"none",
    customToolbarSelect:(selectedRows, displayData, setSelectedRows) =>{
     return (
       <div>
         <Button title="Active" onClick={()=>tripStatus(0,srow)}>
           <MaterialIcons color="action" icon="check_circle_outline_two_tone" size={20}/>
       </Button>
       <Button title="Inactive"  onClick={()=>tripStatus(1,srow)}>
           <MaterialIcons color="secondary" icon="check_circle_outline_two_tone" size={20}/>
       </Button>
       <Button title="Delete"  onClick={()=>tripStatus(2,srow)}>
           <MaterialIcons color="secondary" icon="delete" size={20}/>
       </Button>
       </div>
     )
    },
  };
  return (
     
    <div className={classes.root}>
      
      <Sidebar />
      <main className={classes.content}>
      <div className={classes.toolbar} />
      <Bread data={br} />
       <span>
       <h1 style={{'display':'inline'}}>
       Trip List
       </h1>
       <Button style={{'float':'right'}} variant="contained" color="secondary">
         <Link to={'trip/create'}>
         Add Trip
         </Link>
         </Button>
       </span>
       <Datatable title="Trip List" data={data} columns={columns} options={options}/>
      </main>
    </div>
   
  );
}


// WEBPACK FOOTER //
// ./src/Pages/DestinationList.js